export default class PaymentStatus {
  constructor(
    indexNumber,
    documentNumberFinance,
    messageType,
    messageLineString,
    authorizationReferenceCode,
  ) {
    this.index_number = indexNumber;
    this.document_number_finance = documentNumberFinance;
    this.message_type = messageType;
    this.message_line_string = messageLineString;
    this.authorization_reference_code = authorizationReferenceCode;
  }
}
